import { getHealth, getMaintenanceContent } from './Maintenance.repo'

export const pollMaintenanceInfo = async (reroute) => {
  const interval = 5000
  const response = await getHealth().catch((err) => {
    console.error(err)
  })

  if (response && response.status === 1) {
    reroute()
  } else {
    setTimeout(pollMaintenanceInfo.bind(this, reroute), interval)
  }
}

export const getMaintenanceMessage = async () => {
  const defaultMaintenanceMessage = {
    header:
      'SORRY!',
    subHeader: 'The website is currently under maintenance. We will be back shortly.',
    footerImageUrl: require('../../assets/img/oops.png')
  }

  const maintenanceMessage = await getMaintenanceContent().catch((err) => err)

  return new Promise((resolve) => {
    if (maintenanceMessage.header) {
      resolve({
        header: maintenanceMessage.header['en-US'],
        subHeader: maintenanceMessage.subHeader['en-US'],
        footerImageUrl: maintenanceMessage.footerImage['en-US'].sys.url
      })
    } else {
      resolve(defaultMaintenanceMessage)
    }
  })
}
